import sdk from 'redcatSdk'
import Vue from 'vue'
import { UUID } from '@/plugins/common'
import Index from '@/components/system/index.vue'
import FormRuntime from '@/components/form/runtime/form-runtime'
import DialogFormRuntime from '@/components/shared/dialog-form-runtime.vue'
import ReportRuntime from '@/components/report/runtime/report-runtime.vue'
import ReportFilter from '@/components/report/runtime/report-filter.vue'
import tokenStorage from '@/plugins/tokenStorage'
import cache from '@/components/public/cache'
import axios from '@/plugins/axios'
import CodeService, { EventBus } from '@/store/form-runtime/codeService'
import { componentMixin, inputMixin, defaultValueMixin, ossMixin } from '@/components/form/runtime/components/mixins'

export function initSdk (root) {
  sdk.init(root, {
    Vue,
    UUID,
    routeParent: Index,
    components: {
      FormRuntime,
      DialogComponent: DialogFormRuntime,
      ReportRuntime,
      ReportFilter
    },
    plugins: {
      tokenStorage,
      cache,
      CodeService,
      EventBus,
      componentMixin,
      inputMixin,
      defaultValueMixin,
      ossMixin
    }
  })
  self['Vue'] = Vue
  window.Fn = sdk.Fn
}

export async function loadExtensionScript (resolve = () => {}, reject = () => {}) {
  let publicPath = process.env.PUBLIC_PATH
  let env = process.env.NODE_ENV
  let src = ''
  axios.get('/system-api/redcatSDK').then(res => {
    let sdk = res.data
    src = sdk.path && sdk.version ? (sdk.path.startsWith('http') ? `${sdk.path}?v=${sdk.version}` : `${publicPath}${sdk.path}?v=${sdk.version}`) : ''
    if (src !== '') {
      let exts = document.createElement('script')
      exts.src = src
      let host = window.location.host
      //  cust环境下env为production
      if ((host).indexOf('localhost') === -1 || env !== 'production') {
        document.body.appendChild(exts)
        // 不考虑ie8及以下
        exts.onload = () => resolve(exts)
        exts.onerror = () => reject(exts)
      } else {
        reject(null)
      }
    } else {
      reject(null)
    }
  }).catch(() => {
    reject(null)
  })
}



// WEBPACK FOOTER //
// ./src/plugins/redcatSdk/index.js